import React, { useState, useEffect } from "react";
import { Combobox, Option } from "@fluentui/react-components";
import PropTypes from "prop-types";
import { PropertyOption } from "./PropertyOption";
import { useComboboxStyles, comboboxListboxProps, comboboxPositioning } from "../styles/comboboxStyles";

const ContextBox = ({
  properties,
  selectedOptions,
  setSelectedOptions,
  selectedValue,
  setSelectedValue,
  onContextChangeExternal,
}) => {
  const styles = useComboboxStyles();
  const [query, setQuery] = useState(selectedValue);
  const [filteredProperties, setFilteredProperties] = useState(properties);

  useEffect(() => {
    setFilteredProperties(properties);
  }, [properties]);

  useEffect(() => {
    setQuery(selectedValue);
  }, [selectedValue]);

  const onContextChange = (event, data) => {
    console.log("Selected context:", data);
    setSelectedOptions(data.selectedOptions);
    setSelectedValue(data.optionText);
    setFilteredProperties(properties);
    if (typeof onContextChangeExternal === "function") {
      const selectedKey = Array.isArray(data.selectedOptions) ? data.selectedOptions[0] : undefined;
      onContextChangeExternal({ key: selectedKey, text: data.optionText });
    }
  };

  const onInput = (ev) => {
    console.log("Input:", ev.target.value);
    setQuery(ev.target.value);
    setFilteredProperties(properties.filter((item) => item.text.toLowerCase().includes(ev.target.value.toLowerCase())));
  };

  return (
    <Combobox
      id="contextDropdown"
      label="Conversation context:"
      selectedOptions={selectedOptions}
      onInput={onInput}
      value={query}
      onOptionSelect={onContextChange}
      onChange={(ev) => setQuery(ev.target.value)}
      placeholder="Select a property..."
      className={styles.dropdownMenuCompose}
      style={{ flex: 1 }}
      positioning={comboboxPositioning}
      listbox={comboboxListboxProps(styles.dropdownMenuListbox)}
      input={{ className: styles.comboBoxInput, autoComplete: "off" }}
      size="small"
      tabIndex={0}
    >
      {filteredProperties.map((item) => (
        <Option text={item.text} key={item.key} value={item.key}>
          <PropertyOption text={item.text} selectedValue={selectedValue} />
        </Option>
      ))}
    </Combobox>
  );
};

ContextBox.propTypes = {
  properties: PropTypes.array.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  setSelectedOptions: PropTypes.func.isRequired,
  selectedValue: PropTypes.string.isRequired,
  setSelectedValue: PropTypes.func.isRequired,
  onContextChangeExternal: PropTypes.func,
};

export default ContextBox;
